// Показывать ли коммерцию — ЕДИНСТВЕННОЕ решение на клиенте.
//
// Правило (веб всегда да, Capacitor только по флагу) и поведение при
// неизвестности живут в `@studyhub/shared/module/commerce` — там же, где их
// применяет сервер. Здесь только доступ к значению.
//
// ┌─ Почему тут нет проверки владельца, в отличие от карты модулей ───────────┐
// │ Карта модулей считается ДЛЯ пользователя: тариф и когорты у разных людей  │
// │ разные, поэтому чужую карту показывать нельзя даже на кадр. Признак же    │
// │ показа коммерции зависит ровно от двух вещей — платформы клиента и        │
// │ глобального админского тумблера, — и у всех пользователей на одной        │
// │ платформе он одинаков. Сверять владельца здесь было бы имитацией          │
// │ строгости: она ничего не защищает, но заставляет читателя думать, что     │
// │ значение персональное.                                                    │
// └───────────────────────────────────────────────────────────────────────────┘

import { commerceVisibleFallback } from "@studyhub/shared/module";
import { CLIENT_MODULE_PLATFORM } from "./platform";
import { useModuleAvailabilityStore } from "./store";

/** Синхронное чтение — для `beforeLoad` роутов, где хука быть не может. */
export function isCommerceVisible(): boolean {
	const value = useModuleAvailabilityStore.getState().commerceVisible;
	return value ?? commerceVisibleFallback(CLIENT_MODULE_PLATFORM);
}

/** Реактивное чтение — для компонентов. */
export function useCommerceVisible(): boolean {
	const value = useModuleAvailabilityStore((s) => s.commerceVisible);
	return value ?? commerceVisibleFallback(CLIENT_MODULE_PLATFORM);
}
